export class ImobiliariaForAutocompleteResponse {
    id: number;
    nome: string;

    constructor(p: any) {
        this.id = p.id !== undefined ? p.id : null;
        this.nome = p.nome !== undefined ? p.nome : null;
    }
}